import React from "react";
import styled from "styled-components";
import ContactInfo from "./ContactInfo";
import { Divider } from "@mui/material";

function RenderContacts({ claim, index, contact_length }) {
  return (
    <div style={{ display: "flex" }}>
      <ContactContainer key={index}>
        {claim.cashless_region && (
          <ContactInfo label="Region">{claim.cashless_region}</ContactInfo>
        )}
        {claim.cashless_contact_name && (
          <ContactInfo label="Name">{claim.cashless_contact_name}</ContactInfo>
        )}
        {claim.cashless_contact && (
          <ContactInfo label="Mobile Number" isCopy>
            {claim.cashless_contact}
          </ContactInfo>
        )}
        {claim.cashless_contact_email && (
          <ContactInfo label="Email Address" isCopy>
            {claim.cashless_contact_email}
          </ContactInfo>
        )}
      </ContactContainer>
      <>
        {index !== contact_length - 1 && (
          <Divider
            orientation="vertical"
            style={{ marginRight: "4rem", marginLeft: "4rem" }}
          />
        )}
      </>
    </div>
  );
}

export default RenderContacts;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: fit-content;
`;
